import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_cache_failed",
  "use": "micro_cache_failed-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_cache_failed\"><path fill-rule=\"evenodd\" d=\"M1.817 4.094 6.415 9H2.5a2.5 2.5 0 0 1-.683-4.906ZM5 1c1.657 0 3 1.567 3 3.5 0 .17-.01.338-.03.502L8 5a2 2 0 0 1 .429 3.954L2.477 2.606C3.01 1.64 3.94 1 5 1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol